import { ENV } from '../utils';

export class NodesAPI {
    basePath = ENV.BASE_PATH

    async getNodes(accessToken,statusRequest) {
        console.log(statusRequest)
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.NODES}?status=${statusRequest}`;
            console.log(url);
            
            const params = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            };

            const response = await fetch(url, params);
            const result = await response.json()

            if(response.status !== 200) throw result;
            return result;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async createNode(accessToken, nodeData) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.NODE}`;
            console.log(url);
            const params = {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(nodeData)
            }

            const response = await fetch(url, params);
            console.log(response);
            const result= await response.json();

            if(response.status !== 201) throw result;
            return result;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async updateNode(accessToken, idNode, nodeData) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.NODE}/${idNode}`;
            const params = {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(nodeData),
            }

            const response = await fetch(url, params);
            console.log( response)
            const result = await response.json();

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error
        }
    }

    //DeleteNode 
    async deleteNode(accessToken, idNode) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.NODE}/${idNode}`;
            console.log(url)
            const params = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };
            
            const response = await fetch(url, params);
            // const result = await response.json();
            const result ={}

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    } 

     //approveNode
    async approveNode(accessToken, idNode) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.NODE}/${idNode}${ENV.API_ROUTES.APPROVE_NODE}`;
            console.log(url)
            const params = {
                method : "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }

            const response = await fetch(url, params);
           // const result = await response.json();
            const result ={}
            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    }

    async getNodeExcel(accessToken) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.EXCEL_NODE}`
            console.log(url);
            const params = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                responseType: "blob"
            }

            const response = await fetch(url, params);
            const result = await response.blob();
            const _url = window.URL.createObjectURL(result);
            const _link = document.createElement("a");
            _link.href = _url;
            _link.download = 'nodes.xlsx'
            document.body.appendChild(_link);
            _link.click();


            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}